import React from 'react';
import { Checkbox, Drawer } from 'antd';
import size from 'lodash/size';
import ShippingPolicy from 'components/ShippingPolicy';
import ShippingPolicyTag from 'components/common/ShippingPolicy';
import Table from 'components/DiamondList/TableBack';
import TermsConditionPopup from 'components/TermsConditionPopup';
import Heading from 'components/common/Heading';
import TextArea from 'components/common/TextArea';
import MobileConfirmStone from 'components/common/DiamondListing/MobileComfirmStone';
import SelectStone from 'components/common/DiamondListing/SelectStone';
import { calculate } from './SelectStone';
import { useIsMobile } from 'util/hooks';
import { classNames, isEmpty } from 'util/utils';

import { handleConfirmStone, isMobile } from 'components/DiamondList/DiamondListFunctions';
import OpenNotification from 'components/common/CommonButton/OpenNotification';

const currentType = 'ConfirmStonePopup';
export function HeadingCalc(checked, VALUES = null, isBidDis) {
  if (isMobile() && !checked.length && !VALUES) return null;
  let obj = {};
  if (VALUES) obj = VALUES;
  else {
    let disc = localStorage.getItem('disc');
    let sum = calculate(checked, null, isBidDis);
    obj = {
      'Pieces:': sum.total_pieces,
      'Crt:': parseFloat(sum.total_carat).toFixed(2),
      'Disc% :': parseFloat(sum.final_discount).toFixed(2),
      'Pr/Ct :': parseFloat(sum.final_price).toFixed(2),
      'Amt. :': parseFloat(sum.bid_final_amt).toFixed(2),
    };
  }
  // if (isMobile()) obj = invert(obj);
  if (size(obj) < 4) return null;
  return (
    <div className="DiamondDetailPopup">
      {Object.keys(obj).map((x) => {
        return (
          <div className="DiamondDetailPopupItem" style={VALUES ? checked : {}}>
            <span>{x}</span>
            <span>
              {isMobile()
                ? x === 'Bid Term Discount(%)' || x === 'Avg. Discount(%)' || x === 'TERMS'
                  ? obj[x] > 0
                    ? `+${obj[x]}`
                    : obj[x]
                  : obj[x]
                : obj[x]}
            </span>
          </div>
        );
      })}
    </div>
  );
}

const ConfirmStonePopup = (props) => {
  const [isMobile] = useIsMobile();

  const [termsConditionDrawer, setTermsConditionDrawer] = React.useState(false);
  const [shippingPolicyDrawer, setShippingPolicyDrawer] = React.useState(false);

  const [comment, setComment] = React.useState('');
  const [acceptedTerms, setAcceptedTerms] = React.useState(isMobile);

  const closeDrawer = () => {
    void props.onClose?.();
    void props.clearAll?.();
  };

  const checkSelectedRows = () => {
    const rowsEmpty = isEmpty(props.checked);
    if (rowsEmpty) OpenNotification({ type: 'error', title: 'Please select stone(s) to confirm.' });
    return !rowsEmpty;
  };

  const submit = async () => {
    if (isEmpty(props.checked)) {
      return OpenNotification({ type: 'error', title: 'Please select stone(s)' });
    }

    if (!acceptedTerms) {
      return OpenNotification({ type: 'error', title: 'You must be agree to terms and condition to buy stone' });
    }

    const idList = props.checked.map((record) => record?.id);
    const confirmed = await new Promise((resolve) => handleConfirmStone(idList, comment, resolve));

    closeDrawer();
    if (confirmed) props.fetch();
  };

  const gettextarea = () => (
    <TextArea label="Comment" placeholder="Comment" value={comment} onChange={(e) => setComment(e.target.value)} />
  );

  if (isMobile)
    return (
      <MobileConfirmStone
        data={props.checked}
        currentType={currentType}
        parent={{ submit, cancel: closeDrawer, gettextarea, checkCheck: checkSelectedRows }}
      />
    );

  return (
    <div>
      <div className="d-flex align-items-center offerTopBlock offerWrapper mb-20">
        <Heading className="popupInnerTitle mr-40" title="Confirm Stone"></Heading>
        {!isEmpty(props.checked) && <SelectStone sum={{}} buy currentType={currentType} />}
      </div>
      <div className={classNames(['searchPopupCommonTable', props?.popupClass])} style={props?.style}>
        <div className="searchResultTable tabInnerTableScroll" style={{ height: 360, overflow: 'auto' }}>
          <Table
            data={props.checked}
            currentType={currentType}
            nocheck={Boolean(props.detail)}
            finalDestination
            canSort={false}
            noCheckBox
            nodots
            noGrp
          />
        </div>
        <div className="confirmListOption finalCalDetail">
          <div className="DiamondDetailPopup width-100">
            {gettextarea()}
            <div className="mt-10 width-100">
              <Checkbox checked={acceptedTerms} onChange={() => setAcceptedTerms(!acceptedTerms)}>
                I have read and accept
              </Checkbox>
              <a onClick={() => setTermsConditionDrawer(true)} className="linkTag">
                <strong>Terms and Conditions.</strong>
              </a>
            </div>
            <ShippingPolicyTag />
          </div>
        </div>
        <div className="sideBarPopupButton">
          <a className="commonButton" onClick={submit}>
            Confirm Stone
          </a>
          <a className="commonButton" onClick={() => void (props.onClose?.(), props.clearAll?.())}>
            Cancel Stone
          </a>
        </div>
      </div>
      <Drawer
        visible={termsConditionDrawer}
        onClose={() => setTermsConditionDrawer(false)}
        wrapClassName="diamondListinSidebar"
        destroyOnClose
      >
        <TermsConditionPopup />
      </Drawer>
      <Drawer
        visible={shippingPolicyDrawer}
        onClose={() => setShippingPolicyDrawer(false)}
        wrapClassName="diamondListinSidebar"
        destroyOnClose
      >
        <ShippingPolicy />
      </Drawer>
    </div>
  );
};

export default ConfirmStonePopup;
